export default async (context) => {
    let text = document.getElementById('add-text-page__textarea')
    let event = new Event('keyup', {keyCode: '8'})
    await text.dispatchEvent(event)
    await context.text_blur_input(context)
}